/**
 * @desc 通过spu获取相关联sku列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<string>>;
export function request(spu: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/sku/bySpuGetSkuList/${spu}`, {
      method: "GET",

      ...options,
    }),
  );
}
